import MathHelpers from "../../Math/MathHelpers";
import Monster from "../../Monster";
import IPositioner from "./IPositioner";

export class YAxisPositioner implements IPositioner {
    private mMinY: number;
    private mMaxY: number;

    constructor(minY: number, maxY: number) {
        this.mMinY = minY;
        this.mMaxY = maxY;
    }

    public Position(monster: Monster): void {
        let randomY = MathHelpers.RandomInteger(this.mMinY, this.mMaxY);
        monster.SetPosition(new Phaser.Math.Vector2(monster.GetX(), randomY));
    }
}